import classNames from 'classnames';
import { Checkbox } from '@libs/components';
import { ReactComponent as QuestionIcon } from '@shared/images/svg/question.svg';
import { useRef, useState } from 'react';

import styles from './styles.module.scss';

type Props = {
    value: boolean;
    setValue: (value: boolean) => void;
    disabled: boolean;
};

export const SaveCardCheckbox = ({ value, setValue, disabled }: Props) => {
    const ref = useRef<HTMLDivElement>(null);
    const [showPanel, setShowPanel] = useState<boolean>(false);

    return (
        <div className={classNames(styles.checkboxWrapper, 'flex', 'justify-content-between', 'align-items-center')}>
            <div ref={ref} className={classNames('flex')}>
                <span>Сохранить карту</span>
                <QuestionIcon
                    onClick={() => {
                        setShowPanel((prev) => !prev);
                    }}
                />
                {showPanel && (
                    <div className={styles.overlayPanelWrapper} style={{ bottom: '25px' }}>
                        <p>При следующей оплате вводить данные не потребуется — списание произойдёт автоматически.</p>
                        <p>
                            Сохраняя способ оплаты, Вы соглашаетесь на его автоматическую привязку к вашей учетной
                            записи для списания средств при продлении услуг на нашей платформе.
                        </p>
                        <p>
                            Все данные хранятся в зашифрованном виде. Вы можете в любой момент отвязать способ оплаты и
                            отключить автосписание в личном кабинете
                        </p>
                    </div>
                )}
            </div>
            <Checkbox
                className={styles.checkbox}
                onClick={() => setValue(!value)}
                checked={value}
                disabled={disabled}
            />
        </div>
    );
};
